query getNumberOfLandingpages($isMasterView: Boolean, $childCompanyId: ID) {
  numberOfLandingpages: getNumberOfLandingpages(isMasterView: $isMasterView, childCompanyId: $childCompanyId)
}
